var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_1977)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_936_1977)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_936_1977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24985 9.63602V16.5398H9.31848V9.63602H11.6065L12.0419 6.78016H9.31848V4.92696C9.31848 4.14566 9.69899 3.38404 10.9188 3.38404H12.157V0.952727C12.157 0.952727 11.0333 0.759766 9.95887 0.759766C7.71589 0.759766 6.24985 2.12748 6.24985 4.60355V6.78016H3.75659V9.63602H6.24985Z",
    fill: "#EEF0F2"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_1977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.78,
    height: 15.78,
    fill: "white",
    transform: "translate(0.25 0.759766)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_936_1977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.78,
    height: 15.78,
    fill: "white",
    transform: "translate(0.25 0.759766)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_936_1977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.76667,
    height: 15.78,
    fill: "white",
    transform: "translate(3.75659 0.759766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSmall);
export default __webpack_public_path__ + "static/media/facebook-small.38f0239baec755563a6b6b86b2b4faa1.svg";
export { ForwardRef as ReactComponent };